import 'scss/solutions/financial-AR-solution.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'



// WEBPACK FOOTER //
// ./src/js/entry/solutions/financial-AR-solution.js